import type { RawParams } from '@wix/tpa-router';

import type { StateDeclarationFn } from 'controller/types';

import type { IFeedItem } from 'api/feed';
import { GroupAppKey } from 'store/groups/types';

export default (function (vm, store, params) {
  const { isSSR } = params.flowAPI.environment;

  return {
    name: 'group.discussion.post',
    url: '/:feedItemId?commentId',
    data: {
      application: GroupAppKey.FEED_APP,
    },
    resolve: [
      {
        token: 'feedItem',
        deps: ['$stateParams', 'groupId', 'feedAvailable'],
        resolveFn(
          stateParams: RawParams,
          groupId: string,
          isFeedAvailable: boolean,
        ) {
          if (isFeedAvailable) {
            return vm.feed$.get(groupId, stateParams.feedItemId, false);
          }
        },
      },
      {
        token: 'comments',
        deps: ['feedItem', 'commentsApi'],
        async resolveFn(feedItem?: IFeedItem) {
          if (!isSSR) {
            await vm._.comments.fetch(feedItem ? [feedItem] : []);
          }
        },
      },
    ],
  };
} as StateDeclarationFn);
